import {loadHomePageContent, saveHomePage} from "~/modules/homepage/service";

export function initStorage(editor, homePageUUID: string) {
  editor.StorageManager.add('custom-remote', {
    async load(keys, clb) {

      const content = await loadHomePageContent(homePageUUID);
      let output = {components: [], styles: []};
      try {
        if (content?.components && content?.styles) {
          output = { components: JSON.parse(content.components), styles: JSON.parse(content.styles)};
        }
      } catch (err) {
        console.error(err);
      }
      return clb(output);
    },

    async store(data) {
      await saveHomePage(homePageUUID, data);
    }
  });
}
